import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-sm border-b border-gray-100"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-10 h-[72px] max-w-[1400px] mx-auto">
        {/* Logo + Company Name */}
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 flex items-center justify-center">
            <img
              src="https://public.readdy.ai/ai/img_res/f9bdbb95-fa9b-40b0-ac14-058556f0e253.png"
              alt="KESTEN d. o. o. logo"
              className="w-9 h-9 object-contain"
            />
          </div>
          <span
            className={`text-[17px] font-semibold tracking-tight transition-colors duration-300 ${
              scrolled ? "text-[#0A0A0A]" : "text-white"
            }`}
          >
            KESTEN d. o. o.
          </span>
        </div>

        {/* Nav Links */}
        <ul className="flex items-center gap-10">
          {["about", "products", "contact"].map((item) => (
            <li key={item}>
              <button
                onClick={() => scrollTo(item)}
                className={`text-[14px] font-medium tracking-wide capitalize transition-colors duration-200 cursor-pointer whitespace-nowrap hover:text-emerald-600 ${
                  scrolled ? "text-[#555]" : "text-white/80"
                }`}
              >
                {item.charAt(0).toUpperCase() + item.slice(1)}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
